import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BookingResponse } from "@/api/types";

export function useCancelBooking() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string }) =>
      api.patch(`bookings/${id}/cancel`).json<BookingResponse>(),
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["bookings"] });
      void queryClient.invalidateQueries({
        queryKey: ["businesses", data.business.slug, "availability"],
      });
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      void queryClient.invalidateQueries({ queryKey: ["booking", variables.id] });
    },
  });
}
